import { render, staticRenderFns } from "./marketingTimeindex.vue?vue&type=template&id=70fc55bf&scoped=true&"
import script from "./marketingTimeindex.vue?vue&type=script&lang=js&"
export * from "./marketingTimeindex.vue?vue&type=script&lang=js&"
import style0 from "./marketingTimeindex.vue?vue&type=style&index=0&id=70fc55bf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc55bf",
  null
  
)

export default component.exports